import LocalizedStrings from "react-localization";

export const strings = new LocalizedStrings({
  en: {
    registration: {
      placeholders: {
        name: "Enter Your Name",
        number: "Enter Phone Number",
        // panCard: "Enter Your PAN",
        promoCode: "Enter Promo Code",
      },
      button: {
        start: "START",
      },
      errorMessages: {
        requiredName: "Please enter your name",
        requiredPhone: "Please enter valid number",
        // requiredPan: "Please enter your PAN",
        allowedNumbers: "Maximum 10 numbers allowed",
        enterNumber: "Please enter a number",
        validPan: "Please enter a valid PAN",
        validName: "Please enter a valid name",
      },
    },
  },
  hi: {
    registration: {
      placeholders: {
        name: "अपना नाम दर्ज करें",
        number: "फोन नंबर दर्ज",
        // panCard: "अपना पैन दर्ज करें",
        promoCode: "प्रचार कि नियमावली दर्ज करो",
      },
      button: {
        start: "शुरू",
      },
      errorMessages: {
        requiredName: "कृपया अपना नाम दर्ज करें",
        requiredPhone: "कृपया वैध संख्या दर्ज करें",
        // requiredPan: "कृपया अपना पैन दर्ज करें",
        allowedNumbers: "अधिकतम 10 नंबरों की अनुमति है",
        enterNumber: "एक संख्या दर्ज करें",
        validPan: "कृपया एक वैध पैन दर्ज करें",
        validName: "कृपया एक मान्य नाम दर्ज करें",
      },
    },
  },
});
